import { render, staticRenderFns } from "./PremiumSurveyQuestionPage.vue?vue&type=template&id=528e4be9&scoped=true"
import script from "./PremiumSurveyQuestionPage.vue?vue&type=script&lang=js"
export * from "./PremiumSurveyQuestionPage.vue?vue&type=script&lang=js"
import style0 from "./PremiumSurveyQuestionPage.vue?vue&type=style&index=0&id=528e4be9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e4be9",
  null
  
)

export default component.exports